// src/utils/nav.js

// Keskitetty reititys
export const DASH_USER_QS = "band=user&tab=uprofile";
export const DASH_BAND = (idOrSlug = "auto", tab = "basic") =>
  `/dashboard?band=${encodeURIComponent(String(idOrSlug))}&tab=${encodeURIComponent(tab)}`;

// ---- perusohjaukset ----
export function toLogin(navigate, nextPath = null, replace = true) {
  const next =
    nextPath ??
    (typeof window !== "undefined"
      ? window.location.pathname + window.location.search + window.location.hash
      : "/");
  navigate(`/kirjaudu?next=${encodeURIComponent(next)}`, { replace });
}

export function toOnboarding(navigate, replace = true, state = undefined) {
  navigate("/onboarding", { replace, state });
}

export function toDashboardUser(navigate, replace = true) {
  navigate(`/dashboard?${DASH_USER_QS}`, { replace });
}

export function toDashboardBand(navigate, idOrSlug = "auto", tab = "basic", replace = true) {
  navigate(DASH_BAND(idOrSlug, tab), { replace });
}

// ---- setupin jälkeen / poistojen jälkeen ----
export function afterSetupCreated(navigate, idOrSlug) {
  try { sessionStorage.setItem("setup.completed", "1"); } catch {}
  try { localStorage.setItem("dashboard.hadBandsOnce", "1"); } catch {}
  try { sessionStorage.removeItem("dashboard.skipSetupOnce"); } catch {}
  toDashboardBand(navigate, idOrSlug ?? "auto", "basic", true);
}

export function afterLastBandRemoved(navigate) {
  try { sessionStorage.setItem("dashboard.skipSetupOnce", "1"); } catch {}
  // Pysy Dashboardissa, vaihda vain "Tiliasetukset"-paneeliin
  toDashboardUser(navigate, true);
}

export function afterAccountDeleted() {
  try { localStorage.removeItem("dashboard.hadBandsOnce"); } catch {}
  try { sessionStorage.clear(); } catch {}
  if (typeof window !== "undefined") window.location.assign("/kirjaudu");
}

// Yhtenäinen export myös objektina
export const nav = {
  toLogin,
  toOnboarding,
  toDashboardUser,
  toDashboardBand,
  afterSetupCreated,
  afterLastBandRemoved,
  afterAccountDeleted,
};
